// extracted by mini-css-extract-plugin
export default {"page":"Location_page__niaDw","brand-header":"Location_brand-header__eEQhC","brand-search":"Location_brand-search__gJFZ8","no-results":"Location_no-results__dKDn+"};